import React from 'react';
import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material';

import SaveIcon from '@mui/icons-material/Save';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import DeleteIcon from '@mui/icons-material/Delete';

import CustomButton from 'components/shared/CustomButton';

import { styles } from '../styles';

interface Props {
  tableName: string;
  showDeleteIcon: boolean | string;
  handleSubmit: () => void;
  handleReset: () => void;
  handleDelete?: () => void;
}

const DialogHeader = ({
  tableName,
  showDeleteIcon,
  handleSubmit,
  handleReset,
  handleDelete,
}: Props) => {
  return (
    <>
      <Grid item xs={8}>
        <Box display="flex" alignItems={'center'} px={8} pt={6}>
          <Typography
            variant="body1"
            id="modal-title"
            color="primary"
            style={{ fontSize: '1.25rem' }}
          >
            Configuraci&oacute;n de columna:&nbsp; {tableName}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={4}>
        <Box
          display="flex"
          justifyContent={'flex-end'}
          alignItems={'center'}
          px={6}
          pt={6}
        >
          {showDeleteIcon ? (
            <Tooltip title={'Eliminar'}>
              <IconButton
                aria-label="delete"
                onClick={() => handleDelete && handleDelete()}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : null}

          <Tooltip title={'Reiniciar'}>
            <IconButton aria-label="close" onClick={handleReset}>
              <RotateLeftIcon />
            </IconButton>
          </Tooltip>

          <CustomButton
            color="primary"
            endIcon={<SaveIcon />}
            size={'small'}
            onClick={handleSubmit}
            sx={styles.applyButton}
          >
            Aplicar
          </CustomButton>
        </Box>
      </Grid>
    </>
  );
};

export default DialogHeader;
